import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Digital_add_pro extends Component {
    constructor(props) {
        super(props)
        this.state = {
            category: [],
            image: '',
            parentcategories: [],
            parentCategory: ''
        }
        this.submitHandler = this.submitHandler.bind(this)
    }

    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }

        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        fetch(`${process.env['REACT_APP_HOST']}/api/categories/${lastItem}`)
            .then((response) => response.json())
            .then(result => {
                this.setState({ category: result });
                this.setState({ parentCategory: result.parentCategory })
            });

        fetch(`${process.env['REACT_APP_HOST']}/api/parentcategories`)
            .then((response) => response.json())
            .then(result => {
                console.log(result)
                this.setState({ parentcategories: result });

            });
    }

    submitHandler(e) {
        e.preventDefault();
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        const url = `${process.env['REACT_APP_HOST']}/api/categories/${lastItem}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: e.target.name.value,
                parentId: e.target.parentId.value,
                // image: this.state.image
                parentCategory: this.state.parentCategory
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                toast.success(data)
                setTimeout(() => { this.props.history.push(`${process.env.PUBLIC_URL}/products/digital/digital-category`); }, 3000);
            })
    }

    uploadFileHandler = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('image', file)
        // setUploading(true)
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
            const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
            this.setState({ image: data });
        } catch (error) {
            // console.log(error)
        }
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Edit Category" parent="Digital" />
                <ToastContainer />
                <div className="container-fluid">
                    <div className="row product-adding">
                        <div className="col-xl-6">
                            <div className="card">
                                <div className="card-body">
                                    <form method="post" action="" onSubmit={this.submitHandler}>
                                        <div className="digital-add needs-validation">

                                            <div className="form-group">
                                                <label className="col-form-label"><span>*</span>Parent Category</label>
                                                <select className="custom-select" name="parentCategory" value={this.state.parentCategory} onChange={(e) => this.setState({ parentCategory: e.target.value })} >
                                                    {this.state.parentcategories.map(category => {
                                                        return category._id == this.state.category.parentCategory ?
                                                            <option value={category._id} selected="selected">{category.name}</option> :
                                                            <option value={category._id}>{category.name}</option>
                                                    })}
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label className="col-form-label pt-0"><span>*</span> Name</label>
                                                <input type="text" defaultValue={this.state.category.name} name="name" className="form-control" required="required" ></input>
                                                <input type="hidden" name="parentId" value="0" />
                                            </div>
                                            {/* <div className="form-group">
                                                <label className="col-form-label pt-0"><span>*</span> Image</label>
                                                <input className="form-control" defaultValue={this.state.category.image} name="image" onChange={this.uploadFileHandler} id="validationCustom02" type="file" ></input>
                                            </div> */}

                                            <br></br>
                                            <div className="form-group mb-0">
                                                <div className="product-buttons text-center">
                                                    <input type="submit" name="submit" value="Update" className="btn btn-primary" />
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Digital_add_pro
